import * as React from 'react';

import Messages from './Messages';
import MessengerSubcampaignNav from 'modules/messenger/components/MessengerSubcampaignNav';

type Props = {
  subcampaignId: number
};

class MessengerInfluencer extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { subcampaignId } = this.props;

    return (
      <section className="messenger">
        { /* $FlowIgnore TODO Flow is complaining about variable payment amount not given,
                              making it optional dril down more errors in child components */}
        <Messages
          subcampaignId={subcampaignId}
          type="influencer"
        />
        <MessengerSubcampaignNav />
      </section>
    );
  }
}

export default MessengerInfluencer;
